import { render, staticRenderFns } from "./Builddevice.vue?vue&type=template&id=68b1dc1a&scoped=true"
import script from "./Builddevice.vue?vue&type=script&lang=js"
export * from "./Builddevice.vue?vue&type=script&lang=js"
import style0 from "./Builddevice.vue?vue&type=style&index=0&id=68b1dc1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b1dc1a",
  null
  
)

export default component.exports